import React from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlinePercentage } from 'react-icons/ai';

import SettingsOption, { OptionType } from '../SettingsOption';
import { useFormikContext } from 'formik';
import { shouldEnableOrganizationFee } from 'legacy/events/helpers';

const EventOrganizerFee = () => {
  const { t } = useTranslation(['events']);
  const { values, setFieldValue } = useFormikContext<any>();

  const toggleCommentsPermission = () => {
    setFieldValue('chargeOrganizationFee', !values.chargeOrganizationFee);
  };

  if (values?.groups?.length > 0) {
    return (
      <SettingsOption
        icon={<AiOutlinePercentage size={20} />}
        title={t('events:settings.eventOrganizerFee.title')}
        type={OptionType.Toggle}
        onClick={toggleCommentsPermission}
        disabled={!shouldEnableOrganizationFee(values?.groups)}
        isActive={values?.chargeOrganizationFee}
        tooltipMessage={t('events:settings.eventOrganizerFee.tooltip')}
        disabledTooltipMessage={t(
          'events:settings.eventOrganizerFee.disabledTooltip'
        )}
      />
    );
  }

  return null;
};

export default EventOrganizerFee;
